import Vue from 'vue'
import 'fullpage.js/vendors/scrolloverflow' // Optional. Needed, when using scrollOverflow:true
// import './fullpage.scrollHorizontally.min' // Optional. Needed, when using fullpage extensions
import VueFullPage from 'vue-fullpage.js'

Vue.use(VueFullPage)
